import { createContext, useContext } from 'react';
const context = createContext(undefined);
export const ConfigProvider = context.Provider;
export const useConfig = () => {
    const value = useContext(context);
    if (!value) {
        throw new Error('No config');
    }
    return value;
};
